/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllowedFanNumbersDto } from '../models/AllowedFanNumbersDto';
import type { InboxSplitterResponseDto } from '../models/InboxSplitterResponseDto';
import type { SetAllowedFanNumbersRequest } from '../models/SetAllowedFanNumbersRequest';
import type { SetInboxSplitterFeatureRequest } from '../models/SetInboxSplitterFeatureRequest';
import type { SetSupervisorRequest } from '../models/SetSupervisorRequest';
import type { SupervisorsResponseDto } from '../models/SupervisorsResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FanNumberingDashboardService {
    /**
     * Get supervisors
     * Return all supervisors for this creator
     * @returns SupervisorsResponseDto OK
     * @throws ApiError
     */
    public static getSupervisors({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<SupervisorsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/fan-numbering/{creatorId}/supervisors',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Set supervisors
     * Set the supervisors for this creator
     * @returns any OK
     * @throws ApiError
     */
    public static setSupervisors({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: SetSupervisorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/fan-numbering/{creatorId}/supervisors',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get inbox splitter status
     * Get status of inbox splitter feature (feature flag & settings)
     * @returns InboxSplitterResponseDto OK
     * @throws ApiError
     */
    public static getInboxSplitterStatus({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<InboxSplitterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/fan-numbering/{creatorId}/inbox-splitter',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Set inbox splitter status
     * Disable or enable inbox splitter feature
     * @returns any OK
     * @throws ApiError
     */
    public static setInboxSplitterStatus({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: SetInboxSplitterFeatureRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/fan-numbering/{creatorId}/inbox-splitter',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get allowed fan numbers
     * Returns allowed fan numbers mapped to team members
     * @returns AllowedFanNumbersDto OK
     * @throws ApiError
     */
    public static getAllowedFanNumbers({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<AllowedFanNumbersDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/fan-numbering/{creatorId}/allowed-fan-numbers',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * Set allowed fan numbers
     * Sets allowed fan numbers for team members
     * @returns any OK
     * @throws ApiError
     */
    public static setAllowedFanNumbers({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: SetAllowedFanNumbersRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/fan-numbering/{creatorId}/allowed-fan-numbers',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
